import type { Profile, ProfileDemo } from '../types/common'
const register = {
  namespaced: true,
  state: {
    profiles: [], // 用户上传的资料信息
    profileDemo: new Map() // 资料示例
  },
  getters: {
    getProfiles (state: { profiles: Profile[] }) {
      return state.profiles
    },
    getProfileDemo (state: { profileDemo: Map<number, ProfileDemo[]> }) {
      return state.profileDemo
    }
  },
  mutations: {
    PROFILES (state: { profiles: Profile[] }, value: Profile[]) {
      state.profiles = value
    },
    PROFILE_DEMO (state: { profileDemo:Map<number, ProfileDemo[]>}, value: Map<number, ProfileDemo[]>) {
      state.profileDemo = value
    }
  }
}

export default register
